import { createModel } from "nyax";
import { Company } from "src/models/company";
import { CompanyEntityModel } from "src/store/models/entity/company/entity";
import { createListModel } from "src/store/models/entity/_shared";

export const CompanyListModel = createModel(
  class extends createListModel<Company>({
    setItems: (getContainer, items) =>
      getContainer(CompanyEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(CompanyEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(CompanyEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initialIterator: async (payload: { force?: boolean }) => {
          const { force = true } = payload;
          this._initialIterator({
            initialAction: () =>
              this.dependencies.serviceClient.company.getList(),
            force: force,
          });
        },
      };
    }
  }
);
